import clsx from "clsx";
import shape from "../../assets/img/shapes/frame-shape-03.webp";


const FrameShape03 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-frame-shape-03", props.className)}>
            <img src={shape} alt="rmdr-frame-shape-03" loading="lazy" width={190} height={216} />
        </div>
    )

}

export default FrameShape03;
